<template>
  <footer class="footer-area bg-gray">
    <div class="footer-widget-area bg-3 pt-98 pb-90 fix">
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="single-footer-widget">
              <a href="index.html"
                ><img
                  src="../assets/img/logo/logo.png"
                  style="max-width: 70%;"
                  alt="handstand"
              /></a>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Curabitur a convallis nulla. Ut
              </p>
              <ul>
                <li><i class="zmdi zmdi-email"></i> username@gmail.com</li>
                <li><i class="zmdi zmdi-phone"></i> (+660 256 24857)</li>
                <li><i class="zmdi zmdi-home"></i> Your Address Here</li>
              </ul>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="single-footer-widget">
              <h3>Recent Tweets</h3>
              <div class="single-twitt mb-10">
                <div class="twitt-icon">
                  <i class="zmdi zmdi-twitter"></i>
                </div>
                <div class="twitt-content">
                  <p>
                    @envato good News for today!! We got 2 psd templete weekly
                    top selling quality template in technology category !!!
                  </p>
                  <a href="https://twitter.com/login/"
                    >https://twitter.com/login</a
                  >
                </div>
              </div>
              <div class="single-twitt">
                <div class="twitt-icon">
                  <i class="zmdi zmdi-twitter"></i>
                </div>
                <div class="twitt-content">
                  <p>
                    @envato good News for today!! We got 2 psd templete weekly
                    top selling quality template in technology category !!!
                  </p>
                  <a href="https://twitter.com/login/"
                    >https://twitter.com/login</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 hidden-sm col-xs-12">
            <div class="single-footer-widget">
              <h3>get in touch</h3>
              <form id="contact-form" action="mail.php" method="post">
                <div class="row">
                  <div class="col-sm-6">
                    <input type="text" placeholder="Name" name="name" />
                  </div>
                  <div class="col-sm-6">
                    <input type="text" placeholder="Email" name="email" />
                  </div>
                  <div class="col-sm-12">
                    <textarea
                      cols="30"
                      rows="7"
                      name="message"
                      placeholder="subject"
                    ></textarea>
                    <button type="submit">submit</button>
                  </div>
                </div>
              </form>
              <p class="form-messege"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-text-area fix bg-coffee ptb-18">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="footer-text text-center">
              <span
                >Copyright &copy; <a href="#">Stayfit</a> 2017. All Rights
                Reserved.</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data: () => {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>

<style lang="scss" scoped>
#colophon {
  padding: 1rem 0;
  .logo {
    height: 27px;
    margin-bottom: 1rem;
  }
  .smaller {
    font-size: 90%;
    color: #888;
    & > *:not(:last-child) {
      margin-bottom: 0.3rem;
    }
    svg {
      margin-right: 0.5rem;
    }
  }
  .text-muted {
    opacity: 0.75;
  }
  address {
    margin: 0;
  }
  h4 {
    font-size: 100%;
    font-weight: bold;
    margin-bottom: 1rem;
  }
  a {
    color: inherit;
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    &.inline li {
      display: inline-block;
    }
    a {
      display: inline-block;
      margin-bottom: 0.5rem;
    }
  }
  .social-icon {
    font-size: 1.5rem;
    a {
      margin-right: 0.9rem;
    }
    .fa-facebook {
      color: #3b5998;
    }
    .fa-twitter {
      color: #00aced;
    }
    .fa-youtube {
      color: #d00;
    }
    .fa-instagram {
      color: #c32aa3;
    }
  }
}
@media (max-width: 750px) {
  #colophon {
    padding: 3rem 0;
  }
}
</style>
